import { isAxiosError } from "@ihr-radioedit/sdk-network";
import { PwsShow } from "@ihr-radioedit/inferno-webapi";
import { COAST_MESSAGES } from "../../sites/coast/constants";
import { ZypeEpisodeCategory } from "./types";

export function parsePWSError(
  e: unknown,
  fallback = COAST_MESSAGES.UNEXPECTED_ERROR,
  reasonOverwrite: Record<number, string> = {},
) {
  if (e instanceof Error && e.message.startsWith("[")) {
    try {
      const parsedErrors = JSON.parse(e.message);
      if (Array.isArray(parsedErrors) && parsedErrors[0]?.message) {
        return parsedErrors[0].message;
      }
    } catch {
      // ignore JSON parse errors
    }
  }

  if (!isAxiosError(e)) {
    return (e instanceof Error ? e.message : fallback) || fallback;
  }

  const status = e.response?.status;
  const data = e.response?.data;
  const reason = data?.reason;
  const errors = data?.errors;

  if (Array.isArray(errors) && errors[0]?.message) {
    return errors[0].message;
  }

  if (!status || !reason) {
    return e.message || fallback;
  }

  return reasonOverwrite[status] ?? reason ?? fallback;
}

export class PremiereWebServiceError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PremiereWebServiceError";
  }
}

const PWS_SITE_SLUG_TO_SHOW: Record<string, PwsShow> = {
  coast: PwsShow.Coast,
  "coast-pr": PwsShow.Coast,
  "coast-sandbox": PwsShow.Sandbox,
  "clay-and-buck": PwsShow.ClayAndBuck,
};

const PWS_SITE_SLUG_TO_PROPERTY: Record<string, string> = {
  coast: "coast",
  "coast-pr": "coast",
  "coast-sandbox": "coast",
  "clay-and-buck": "clay-and-buck",
};

export const siteSlugToShow = (siteSlug: string): PwsShow => {
  const match = PWS_SITE_SLUG_TO_SHOW[siteSlug];
  if (!match) {
    throw new Error(`No PWS Service site match for slug ${siteSlug}`);
  }
  return match;
};

export const siteSlugToProperty = (siteSlug: string): string => {
  const match = PWS_SITE_SLUG_TO_PROPERTY[siteSlug];
  if (!match) {
    throw new Error(`No PWS Service property match for slug ${siteSlug}`);
  }
  return match;
};

export const coastMediaEpisodeCategoriesToGroupSlug = (categories: ZypeEpisodeCategory[]) => {
  const categoryToGroupSlug: Record<string, string> = {
    Library: "library",
    "Insider Audio": "insider-audio",
    "Art Bell Vault": "art-bell-vault",
  };

  for (const group of categories) {
    if (group.title === "Group") {
      if (!group.value.length) {
        return categoryToGroupSlug.Library;
      }

      for (const category of group.value) {
        if (category in categoryToGroupSlug) {
          return categoryToGroupSlug[category];
        }
      }
    }
  }

  throw new Error("Couldn't get group slug from categories");
};
